import { IPoint } from '@sparelabs/geography'

/**
 * Note: this should be kept equivalent to ApproximateRoutingCosts.scala in `route-optimization-service`
 */
export class ApproximateRoutingCosts {
  // Very approximate - here we aren't bothering to account for the curvature of the Earth
  private static readonly M_IN_DEGREE: number = 111_111

  // We generally can't drive in directly straight lines
  private static readonly DRIVING_DISTANCE_BUFFER: number = 1.1

  // 35 km per hour, in meters per second - accounting for traffic lights, traffic, etc.
  private static readonly DRIVING_SPEED_METERS_PER_SECOND: number = (35.0 * 1000) / (60 * 60)

  public static getDistance(from: IPoint, to: IPoint): number {
    const degreesOfDifference =
      Math.abs(from.coordinates[0] - to.coordinates[0]) + Math.abs(from.coordinates[1] - to.coordinates[1])
    return degreesOfDifference * this.M_IN_DEGREE * this.DRIVING_DISTANCE_BUFFER
  }

  public static getDuration(from: IPoint, to: IPoint): number {
    return this.getDistance(from, to) / this.DRIVING_SPEED_METERS_PER_SECOND
  }
}
